/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import NodeRSA from 'node-rsa';
import { set } from 'lodash';
import { Typography, Menu, Dropdown, Modal } from 'antd';
import { WarningOutlined, UserOutlined } from '@ant-design/icons';
import { remove_jwt } from 'src/core/actions/jwt_token';
import { set_month } from 'src/core/actions/data_date';
import newAlert from 'src/components/newAlert';
import headerImg from 'src/assets/images/mainLogo.png';
import imgLogo from 'src/assets/images/newLogo.png';
import { useHubspotChat } from 'src/core/layout/hubSpot';
import { WS_DISCONNECT } from 'src/core/actions/socket';
import TmzTables from 'src/components/tmz/tmzTables'; // Adjust the path as needed

const { Title } = Typography;
const { confirm } = Modal;

const CompanyList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const socket = useSelector((state) => state.socket);
  const jwt_token = useSelector((state) => state.jwt_token);
  const rsa = useSelector((state) => state.rsa);

  const { addWidget } = useHubspotChat(
    process.env.HUBSPOT_PORTAL_ID || 21532402
  );

  const handleLogout = () => {
    document.cookie.split(';').forEach((c) => {
      document.cookie = c
        .replace(/^ +/, '')
        .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
    });
    localStorage.removeItem('taxjwt');
    dispatch(WS_DISCONNECT(socket));
    dispatch(remove_jwt());
    history.push('/login');
  };

  const showLogoutConfirm = () => {
    confirm({
      title: 'Та гарахдаа итгэлтэй байна уу?',
      icon: <WarningOutlined />,
      okText: 'Тийм',
      okType: 'danger',
      cancelText: 'Үгүй',
      onOk: handleLogout,
    });
  };

  const menuLogout = (
    <Menu>
      <Menu.Item
        className="custom-menu-item bottom"
        onClick={showLogoutConfirm}
      >
        Гарах
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="company-list-container">
    <nav
      className="nav-bar"
      style={{
        display: 'flex',
        backgroundColor: '#fff',
        pointerEvents: 'none',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)', // bottom border shadow
      }}
    >
        <div className="logo-container">
          <a href="/">
            <img src={imgLogo} alt="Logo" />
          </a>
        </div>
        <div className="account-section">
          <Dropdown
            overlay={menuLogout}
            placement="bottomRight"
            trigger={['click']}
          >
            <UserOutlined
              style={{ marginLeft: 10, marginRight: 10, fontSize: 18 }}
            />
          </Dropdown>
        </div>
      </nav>
      <div className="inside-box">
        <header className="header">
          <Title level={5} style={{ marginLeft: 30 }}>
            TMЗ ажлын тайлан, зөвлөмж
          </Title>
        </header>
        <div className="content">
          <TmzTables />
        </div>
      </div>
    </div>
  );
};

export default CompanyList;
